const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};

export const articles = [
  {
    id: createSlug("About"),
    title: "About LoonLog",
    date: "",
    author: "",
    inLanding: true,
    authorImage: "/blog-images/author.png",
    category: "ABOUT",
    image: "/blog-images/3d_v2/loonlog-about-us-info.webp",
    summary:
      "Inspired by the loonie, LoonLog is a digital home for the Canadian spirit. Built on pride and privacy, our mission is to empower local communities through secure, homegrown innovation.",
    content: `
<p>LoonLog was born from a symbol every Canadian knows: the loon on our dollar coin — the Loonie. The Canadian common loon represents pride, resilience, independence, and the natural spirit of the country we call home.</p>
Our name reflects that identity:
<ul>
<li><strong>Loon</strong> — the iconic bird that symbolizes Canada.</li>
<li><strong>Log</strong> — a place to share, connect, express, and record your story.</li> 
</ul>
<p>Together, LoonLog represents a digital home rooted in who we are as Canadians.</p>
<h2>Why We Built LoonLog</h2>
<p>We believe Canadians deserve a platform that reflects our culture, our communities, and our values. LoonLog is built on the same qualities that define the loon itself: strength, clarity, community, and a voice that carries across the water — just as Canadian stories carry across the country.</p>
<p>LoonLog brings together what Canadians value most: belonging, creativity, community, safety, and identity. It is a space designed to feel familiar, respectful, and truly local.</p>
<p>From neighbourhood highlights to national conversations, LoonLog gives Canadians a place they can proudly call their own.</p>
<h2>Our Mission</h2>
<p>Our mission is to create a welcoming, community-driven platform that empowers Canadians to connect, share, learn, and thrive — all within a space built here at home.</p>
<h2>Our Values</h2>
<ul style="margin-top:-20px;">
<li>Built in Canada</li>
<li>Community-focused</li>
<li>Privacy-respecting</li>
<li>Celebrating Canadian culture</li>
<li>Safe and positive for everyone</li>
</ul>
<h2>Innovation and Protection</h2>
<p>Certain LoonLog systems are protected by a pending Canadian patent filing (CIPO Application No. 3292395). This filing covers our integrated social media system, including secure file sharing, educational features, and community-based ride-sharing functionality.</p>
<p>LoonLog is more than a platform. It is the digital expression of the Canadian spirit — strong, proud, and unmistakably ours.</p>`,
  },
  {
    id: createSlug("Privacy Policy"),
    title: "Privacy Policy",
    date: "",
    author: "",
    inLanding: false,
    summary: "",
    authorImage: "/blog-images/author.png",
    category: "PRIVACY POLICY",
    image: "/blog-images/3d_v2/loonlog-privacy-policy-info.webp",
    content: `<h2>Public and Private Information</h2>
<p>Profiles and Posts Are Public:The LoonLog App is a microblogging service for public conversation. Any information you add to your public profile and the posts you make are publicly visible.</p>
<p>Direct Messages Are Private: Content sent via Direct Messages (DMs) is private between you and the recipient(s). However, if shared through a third-party service, that content may become visible to those parties.</p>
<h2>Updates to This Notice</h2>
<p>We may update this Privacy Notice periodically. Changes will be posted on the LoonLog App or the LoonLog website. Additional notifications may also be sent.</p>
<h2>Data Collection and Storage</h2>
<p>This app collects and stores the following types of user data:</p>
<p>Camera and Microphone: Used to capture video and audio for activity logs. Media is stored securely and is only accessible by the user.</p>
<p>Location: Used to tag logs with the user’s current current location. This data is not shared and is stored securely.</p>
<p>User-Generated Content: Any posts, comments, or media shared by users are subject to moderation and must comply with the Terms of Service.</p>
<h2>How We Use Personal Information</h2>
<p>• To provide the LoonLog App Services<br>
• For administrative and app improvement purposes<br>
• For marketing and promotional communications<br>
• With your consent<br>
• For other lawful or requested purposes</p>
<h2>How We Share Your Personal Information</h2>
<p>• To provide and support the LoonLog App<br>
• To protect our rights, your safety, or the safety of others<br>
• As part of corporate transactions, such as mergers or acquisitions</p>
<h2>Your Privacy Rights and Choices</h2>
<p>You may be able to manage communication preferences and control optional features. Some jurisdictions may provide additional rights over your personal data.</p>
<h2>International Data Transfers</h2>
<p>Your personal information may be transferred internationally in accordance with applicable laws.</p>
<h2>Data Retention</h2>
<p>We retain your personal data only as long as necessary to fulfill the purposes for which it was collected.</p>
<h2>Jurisdiction-Specific Notices</h2>
<p>Certain regions may have specific privacy rights and requirements.</p>
<h2>PIPEDA Compliance (Canada)</h2>
<p>As loonlog is based in Canada, we comply with thePersonal Information Protection and Electronic Documents Act (PIPEDA). This means:</p>
<p>• We collect personal information with your knowledge and consent.<br>
• We use it only for the purposes specified at the time of collection.<br>
• We safeguard your information with appropriate security measures.<br>
• You have the right to access, correct, or withdraw consent regarding your data.</p>
<p>For more information, visit the Office of the Privacy Commissioner of Canada: <a href="http://priv.gc.ca">priv.gc.ca</a></p>
<h2>Security</h2>
<p>We take reasonable steps to protect your personal data from unauthorized access or disclosure.</p>
<h2>Children’s Privacy</h2>
<p>The loonlog App is not intended for children and does not knowingly collect their personal data.</p>
<h2>Local Market Activity</h2>
<p>We collect information related to your use of the Local Market, such as item listings, messages between users, and activity logs. This information is used solely to operate the service, protect users, and enforce our terms.</p>
<h2>Ratings and Flags</h2>
<p>When you rate a post or flag content, that information is stored as part of your account activity. We use this data to:</p>
<p>Show aggregate community ratings (e.g., average star score on a post)<br>
Improve moderation tools and keep the platform safe</p>
<p>Your individual ratings are not shared publicly with your name attached; only aggregated scores are displayed. We do not sell or transfer this data to third parties.</p>
<h2>Account Deletion</h2>
<p>You may delete your LoonLog account at any time by navigating to:</p>
<p>Settings → Privacy & Security → Delete Account</p>
<p>Once you confirm deletion, your account profile, posts, comments, and associated personal information will be permanently removed from active use within the platform.</p>
<p><b>Please note:</b></p>
<p>• Account deletion is irreversible.<br/>
• Certain limited information may be retained where required for legal, regulatory, fraud prevention, or security purposes.<br/>
• Backup systems may retain encrypted copies for a limited period before automatic deletion.</p>
<h2>Questions?</h2>
<p>If you have questions about our privacy practices,<br/>please contact us at: 📧 <a href="mailto:admin@loonlog.ca">admin@loonlog.ca</a></p>`,
  },
  {
    id: createSlug("Terms of Service"),
    title: "Terms of Service",
    date: "",
    author: "",
    summary: "",
    authorImage: "/blog-images/author.png",
    inLanding: false,
    category: "TERMS OF SERVICE",
    image: "/blog-images/3d_v2/loonlog-terms-of-service-info.webp",

    content: `<h2>1. Acceptance of Terms</h2>
<p>By accessing or using the LoonLog App or website, you agree to be bound by these Terms of Service (“Terms”). If you do not agree to these Terms, you may not use LoonLog.</p>
<h2>2. Description of Service </h2>
<p>LoonLog is a public microblogging platform designed for sharing short messages, profiles, and media with other users. Some content may be publicly visible and indexed by search engines.</p>
<h2>3. User Responsibilities</h2>
<p>• You are responsible for your account, content, and interactions on LoonLog.<br>
• You agree not to use LoonLog for illegal, harmful, or abusive purposes.<br>
• You must not impersonate others or misrepresent your identity.</p>
<h2>4. Content Ownership and Rights</h2>
<p>You retain ownership of the content you post. By posting on LoonLog, you grant LoonLog a license to use, display, and distribute that content in connection with the operation and promotion of the service.</p>
<h2>5. Privacy</h2>
<p>Your use of LoonLog is also governed by our Privacy Policy, which explains how we collect, use, and protect your information in compliance with Canadian privacy law, including PIPEDA.</p>
<h2>6. Termination</h2>
<p>We may suspend or terminate your access to LoonLog at any time if you violate these Terms or if required by law. You may also delete your account at any time through your profile settings.</p>
<h2>7. Modifications</h2>
<p>LoonLog reserves the right to update these Terms at any time. Changes will be posted on the LoonLog App or website. Continued use of LoonLog after updates means you accept the revised Terms.</p>
<h2>8. Limitation of Liability</h2>
<p>loonlog is provided “as is” and “as available.” We do not guarantee uninterrupted or error-free service. To the fullest extent permitted by law, LoonLog is not liable for damages resulting from your use of the service.</p>
<h2>9. Zero Tolerance Policy for Objectionable Content</h2>
<p>We maintain a strict zero tolerance policy for objectionable content and abusive behavior. This includes, but is not limited to, content that is offensive, hateful, threatening, harassing, defamatory, discriminatory, sexually explicit, or promotes violence.</p>
<h2>10. User Responsibilities</h2>
<p>Users are solely responsible for the content they create, submit, or share through the app. By using this app, users agree not to post any content that violates these Terms of Service or any applicable laws and regulations.</p>
<h2>11. Content Moderation and Reporting</h2>
<p>We provide tools for users to report content they believe violates these terms. All reports will be reviewed by our moderation team, and appropriate action will be taken within 24 hours, including the removal of content and/or suspension of user accounts.</p>
<h2>12. User Blocking</h2>
<p>Users have the ability to block other users to prevent further interaction and exposure to potentially harmful or abusive content. Blocking is an immediate action that takes effect instantly.</p>
<h2>13. Filtering and Automated Monitoring</h2>
<p>We use automated systems to filter and detect objectionable content. These systems help to proactively prevent the publication of content that may violate our policies or community standards.</p>
<h2>14. Enforcement</h2>
<p>We reserve the right to suspend or permanently ban any user who violates our Terms of Service, without prior notice. Offending content will be removed promptly upon discovery or report.</p>
<h2>15. Governing Law</h2>
<p>These Terms are governed by the laws of the Province of British Columbia and the federal laws of Canada applicable therein. Any legal disputes must be brought in the courts of British Columbia.</p>
<h2>16. Marketplace Use & User Responsibilities</h2>
<p>Our website includes a marketplace feature that allows users to list, buy, and sell items locally. By using the marketplace, you agree to the following: You are solely responsible for the items you post, sell, or purchase. You must ensure your listings are accurate, legal, and do not violate any applicable laws or regulations. LoonLog Inc. is not a party to any transaction and does not guarantee the quality, safety, legality, or delivery of any items listed or sold. You use the marketplace at your own risk. We do not conduct background checks or verify user identities, though we reserve the right to remove users or content at our discretion. All marketplace content is user-generated. LoonLog Inc. claims no ownership of user listings but reserves the right to moderate or remove any content that violates our policies.</p>
<h2>17. Disclaimer on Ratings and Stars</h2>
<p>Any ratings, stars, or other feedback shown within LoonLog reflect the opinions of our users. They do not represent statements of fact by LoonLog, and we do not guarantee the accuracy, reliability, or truth of any rating.<br>
By using LoonLog, you agree that you will not rely solely on community ratings for decision-making and that LoonLog is not responsible for damages arising from reliance on such feedback.</p>
<h2>18. Community Fare Policy</h2>
<p>Rides arranged through this platform operate on a community cost-sharing basis — not as a commercial transportation service.<br>
Each fare shown in the app represents a fair contribution toward the driver’s real costs, including:<br>
fuel consumption, pickup distance (base fare), short waiting or traffic time, and a small driver appreciation bonus (about 10%) to support local volunteers.<br>
All fares are calculated automatically using distance and time data provided by Google Maps. Drivers are independent community members, not employees or contractors of the platform, and they are responsible for following all applicable traffic and safety laws. The platform does not take a commission from fares and does not provide taxi or ride-hailing services.<br>
By using the ride-sharing feature, riders agree that payments represent a shared fuel and time contribution, not a transportation fee for hire.</p>
<h2>19. Contact</h2>
<p>If you have any questions about these Terms, please contact us:</p>
<p>📧 <a href="mailto:admin@loonlog.ca">admin@loonlog.ca</a></p>`,
  },
  {
    id: createSlug("Child Safety Policy"),
    title: "Child Safety Policy",
    date: "",
    author: "",
    summary: "",
    inLanding: false,
    authorImage: "/blog-images/author.png",
    category: "CHILD SAFETY POLICY",
    image: "/blog-images/3d_v2/loonlog-child-safety-policy-info.webp",
    //     content: `<b>Canadian Compliance</b>

    // <b>As a Canadian company, we adhere to:</b>

    // •  Canada's Bill C-11 (Digital Charter Implementation Act)
    // •  Reporting obligations to Cybertip.ca, Canada's national tipline for reporting online child exploitation
    // •  PIPEDA for data protection

    // Profiles and Posts Are Public:The LoonLog App is a microblogging service for public conversation. Any information you add to your public profile and the posts you make are publicly visible.
    // Zero Tolerance Policy

    // 18+ Platform: Strictly for users aged 18+ with age verification during signup.

    // <b>Prohibited Content: All CSAE material is removed and reported to:</b>

    // •  <a href="https://www.cybertip.ca/"> Cybertip.ca (Canadian Centre for Child Protection) </a>
    // •   <a href="https://www.cybertip.ca/">NCMEC (for international reports)</a>

    // <b>Reporting</b>

    // Immediate action taken for:

    // •  CSAM (Child Sexual Abuse Material)
    // •  Grooming behavior
    // •  nderage users

    // <b>Report to:</b>

    // 📧 <a href="mailto:admin@loonlog.ca">admin@loonlog.ca</a>
    // (Canadian-based team monitoring 24/7)

    // <b>Legal References</b>

    // •  <a href="https://www.justice.gc.ca/eng/cj-jp/victims-victimes/child-enfant.html">Canadian child exploitation laws</a>
    // •  <a href="https://www.priv.gc.ca/">Office of the Privacy Commissioner of Canada</a>`
    content: `<h2>Canadian Compliance</h2>
<p>As a Canadian company, we adhere to:</p>
<p>• Canada's Bill C-11 (Digital Charter Implementation Act)<br>
• Reporting obligations to Cybertip.ca, Canada's national tipline for reporting online child exploitation<br>
• PIPEDA for data protection</p>
<p>Profiles and Posts Are Public:The LoonLog App is a microblogging service for public conversation. Any information you add to your public profile and the posts you make are publicly visible.</p>
<h2>Zero Tolerance Policy</h2>
<p>18+ Platform: Strictly for users aged 18+ with age verification during signup.</p>
<p>Prohibited Content: All CSAE material is removed and reported to:</p>
<p>• <a href="https://www.cybertip.ca/"> Cybertip.ca (Canadian Centre for Child Protection) </a><br>
• <a href="https://www.cybertip.ca/">NCMEC (for international reports)</a></p>
<h2>Reporting</h2>
<p>Immediate action taken for:</p>
<p>• CSAM (Child Sexual Abuse Material)<br>
• Grooming behavior<br>
• nderage users</p>
<p>Report to:</p>
<p>📧 <a href="mailto:admin@loonlog.ca">admin@loonlog.ca</a><br>
(Canadian-based team monitoring 24/7)</p>
<h2>Legal References</h2>
• <a href="https://www.priv.gc.ca/">Office of the Privacy Commissioner of Canada</a></p>
`,
  },
  {
    id: createSlug("FAQ"),
    title: "FAQ",
    date: "",
    author: "",
    summary: "",
    inLanding: false,
    authorImage: "/blog-images/author.png",
    category: "FAQ",
    image: "/blog-images/3d_v2/loonlog-faq-info.webp",

    //     content: `<b>❓ How do I reset my password?</b>

    // Click "Forgot Password" on the login page or contact us atadmin@loonlog.ca.

    // <b>❓ How are the exams and high school materials made?</b>

    // We use AI to generate original practice exams and study content based on common educational topics. This content is not copied from any official curriculum or publisher and is not affiliated with any education board. It's meant to help students learn and prepare.

    // <b>❓ What do the stars mean on posts?</b>

    // Community Ratings (Stars) LoonLog uses a ⭐ star system to let the community rate posts.
    // Stars are not fact checks and do not represent the absolute truth of any post.

    // They are simply a way for users to share their opinion on how trustworthy, relevant, or valuable they find the content.

    // <b>Please use stars responsibly:</b>

    // ⭐ High ratings = the content feels helpful, trustworthy, or well-made.
    // ⭐ Low ratings = the content feels misleading, low quality, or not valuable.

    // These ratings are visible to everyone as a community signal, but they do not replace independent fact-checking or professional judgment.`,
    //   },
    content: `<h2>How do I reset my password on LoonLog?</h2>
<p>To reset your password, click <strong>“Forgot Password”</strong> on the LoonLog login page and follow the instructions sent to your email. If you need additional help, you can contact our support team at <a href="mailto:admin@loonlog.ca">admin@loonlog.ca</a>.</p>
<h2>How are exams and high school study materials created on LoonLog?</h2>
<p>LoonLog uses AI technology to generate original practice exams and study materials based on common educational topics. This content is independently created, is not copied from any official curriculum or publisher, and is not affiliated with any school board or examination authority. The goal is to help students practice, learn, and prepare more effectively.</p>
<h2>What do the star ratings on posts mean?</h2>
<p>LoonLog uses a community star rating system that allows users to express how helpful, relevant, or valuable they find a post.</p>
<p>Star ratings are <strong>not</strong> fact checks and do not represent verified truth or professional judgment. They are simply a community signal reflecting user opinions.</p>
<p><strong>How to interpret star ratings:</strong></p>
• ⭐ Higher ratings indicate content that users find helpful, trustworthy, or well-presented.</li>
• ⭐ Lower ratings indicate content that users feel is misleading, low quality, or not useful.</li>

<p>Star ratings are visible to the community and are meant to encourage thoughtful participation, but they do not replace independent verification or expert advice.</p>
<h2>Is LoonLog a Canadian-owned platform?</h2>
<p>Yes. LoonLog is a Canadian-owned social media platform built in Canada for Canadian communities. It is designed with a focus on trust, privacy, and community-first engagement, offering a uniquely Canadian digital experience.</p>`,
  },
  {
    id: createSlug("Contact Us"),
    title: "Contact Us",
    date: "",
    author: "",
    summary: "",
    inLanding: false,
    authorImage: "/blog-images/author.png",
    category: "CONTACT US",
    image: "/blog-images/3d_v2/loonlog-contact-us-info.webp",
    content: `📧 Email
admin@loonlog.ca
*Typically respond within 24 hours.*
📞 Phone
1-866-603-2259
🏢 Office

LOONLOG INC.

Greater Vancouver Area (Burnaby)

Canada`,
  },
  {
    id: createSlug("info"),
    title: "",
    date: "",
    summary: "",
    inLanding: false,
    author: "",
    authorImage: "/blog-images/author.png",
    category: "© 2025 LoonLog Inc",
    image: "/blog-images/LoonLog_Patent.webp",
    content: `🇨🇦 Patent Pending · CIPO 3292395
© ${new Date().getFullYear()} LoonLog Inc.

<a href="admin@loonlog.ca">Email</a> <a href="https://www.facebook.com/profile.php?id=61581387360529">Facebook</a> <a href="https://www.youtube.com/channel/UCTUDVeHnV_fkYCEpkqxAlGQ">YouTube<a> <a href="https://www.tiktok.com/@loonlog">Tiktok</a> <a href="https://x.com/LoonLogCanada">X</a> <a href="https://www.instagram.com/loonlog.social/?hl=en">Instagram</a?`,
  },
];
